import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'productTypeVariants',
  component: lazyLoad('Admin/Data/ProductTypeVariants'),
}
